export const createQueryGroup = (id, entity, properties) => ({
  sequence: id,
  entity_params: {
    entity: entity,
    field: null,
    operator: null,
    term: null,
  },
  nested_params: [],
  properties,
})

export const createNestedParams = (id, union) => ({
  sequence: id,
  logical_operator: union,
  field: null,
  operator: null,
  term: null,
})

export const cleanQueryGroups = queryGroups => queryGroups.map(({ properties, ...queryGroup }) => {
  return {
    ...queryGroup,
    entity_params: queryGroup.entity_params,
    nested_params: queryGroup.nested_params,
  }
})

export const createRequestFromState = state => {
  return {
    indistinct_results: state.indistinctResults,
    query_groups: cleanQueryGroups(state.query_groups),
    logical_operator: state.interGroupOperator,
    result_params: {
      entity: state.entity,
    },
  }
}

export const createSearchResults = () => ({
  columns: [],
  rows: [],
  total_found: null,
  warnings: [],
})
